import { gql } from "@apollo/client";

export const GET_SINGLE_POST = gql`
  query GetSinglePost($slug: ID!) {
    post(id: $slug, idType: SLUG) {
      id
      title
      date
      content
      featuredImage { node { sourceUrl altText } }
      author { node { name } }
      tags { nodes { id name slug } }
    }
  }
`;
